import { useQuery } from '@tanstack/react-query';
import { MeetingNoteSectionDrafts } from './types';

export function useMeetingNoteDrafts(companyId: string, meetingNoteId: string | null) {
  return useQuery<MeetingNoteSectionDrafts>({
    queryKey: ['admin', 'companies', companyId, 'meeting-notes', meetingNoteId, 'section-drafts'],
    enabled: !!meetingNoteId,
  });
}
